"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSyncShiftMiddleware = void 0;
const util_1 = require("@app/util");
const react_1 = __importDefault(require("react"));
const useSyncShiftMiddleware = ({ setToggledSections, }) => {
    const syncShiftSections = react_1.default.useCallback((details) => {
        const newStaticSections = [];
        const sections = [];
        if ((0, util_1.isValue)(details.agenda) && details.agenda.length > 0) {
            newStaticSections.push('agenda');
        }
        if (details.pausesFixed === true) {
            newStaticSections.push('manual-pause');
        }
        else {
            newStaticSections.push('automatic-pause');
        }
        if ((0, util_1.isValue)(details.overTime)) {
            newStaticSections.push('overtime');
        }
        if (details.note) {
            newStaticSections.push('note');
        }
        if ((0, util_1.isValue)(details.localityId)) {
            newStaticSections.push('localities');
        }
        if ((0, util_1.isValue)(details.idealSkill)) {
            newStaticSections.push('experience');
        }
        if (details.standBy) {
            newStaticSections.push('emergency');
        }
        details.customAttributes?.forEach((attribute) => {
            sections.push(attribute.attributeId);
        });
        setToggledSections([...newStaticSections, ...sections]);
    }, [setToggledSections]);
    return syncShiftSections;
};
exports.useSyncShiftMiddleware = useSyncShiftMiddleware;
